import React, { useState, useEffect } from "react";
import { Route, Redirect, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { checkRole } from "../../utils/role";
import Unauthorized from "./Unauthorized";

// AWS
import { Auth } from "aws-amplify";

const ProtectedRoute = ({ component: Component, groups = [], ...rest }) => {
  const { user } = useSelector((state) => state.initializeApp);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (user) {
          if (checkRole(user.groups, groups)) {
            return <Component {...rest} {...props} />;
          }

          return <Unauthorized />;
        } else {
          return (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
};

export default ProtectedRoute;
